import { useQuery } from '@tanstack/react-query';
import {
  getSuperstarDetails,
  getSuperstarDetailsLegacy,
  getSuperstars,
} from '../../services/client/superstar';
import {
  QUERY_KEY_SUPERSTAR,
  QUERY_KEY_SUPERSTAR_DETAILS,
} from '../../utils/constants/query-key';

export const useSuperstars = () => {
  return useQuery({
    queryKey: [QUERY_KEY_SUPERSTAR],
    queryFn: getSuperstars,
  });
};

export const useSuperstarDetailsLegacy = ({ id }: { id: string }) => {
  return useQuery({
    queryKey: [QUERY_KEY_SUPERSTAR_DETAILS, id],
    queryFn: async () => {
      const data = await getSuperstarDetailsLegacy(id);
      return data.data;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useSuperstarDetails = ({ id }: { id: string }) => {
  return useQuery({
    queryKey: [QUERY_KEY_SUPERSTAR_DETAILS, id],
    queryFn: async () => {
      const data = await getSuperstarDetails(id);
      return data.data;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
